/**
 * Content body for a patient treatment slot: time, patient, therapy meta and
 * the sublocality strip. Draft placements reuse this (a draft IS a tentative
 * appointment); the frame's `is-draft` class provides the visual distinction.
 */
import React from "react";
import {
  MCEventContentProps,
  MetaRow,
  SublocalityStrip,
  TimeRange,
  wantsFullStrip,
} from "./parts";

const AppointmentContent: React.FC<MCEventContentProps> = ({ event, isCompact }) => (
  <>
    <TimeRange event={event} />
    <span className="mc-event-title">{event.patientLabel || event.title}</span>
    <MetaRow event={event} />
    <SublocalityStrip event={event} full={wantsFullStrip(event, isCompact)} />
  </>
);

export default AppointmentContent;
